import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import { Button } from '../../../styled/buttons/Button';
import { Img } from '../../../styled/miscellaneous/img';
import { elementContains } from '../OutsideClose';
import TableSelect, { ITableSelectProps } from './TableSelectTable/TableSelect';

const dropdownHeight = 300;

interface IProps extends ITableSelectProps {
  style?: React.CSSProperties;
  onChangeValue?: (newValue: string) => void;
}

const TableSelectButton: FC<IProps> = ({
  style,
  onChangeValue: propsOnChangeValue,
  ...tsProps
}) => {
  const divRef = React.createRef<HTMLDivElement>();
  const buttonRef = React.createRef<HTMLButtonElement>();
  const [showSelect, setShowSelect] = useState(false);
  const [btnText, setBtnText] = useState(getDefaultBtnText(tsProps));

  const onChangeValue = (newValue: string) => {
    const btnText = tsProps.items.find(({ value }) => value === newValue)?.title;
    setBtnText(btnText ?? newValue);
    closeSelect();
    propsOnChangeValue && propsOnChangeValue(newValue);
  };

  const closeSelect = () => {
    setShowSelect(false);
  };

  useEffect(() => {
    const handleMouseClick = (event: MouseEvent) => {
      if (
        event.target &&
        divRef.current &&
        !elementContains(divRef.current, event.target as HTMLElement) &&
        event.target !== buttonRef.current
      ) {
        setShowSelect(false);
      }
    };
    document.addEventListener('mousedown', handleMouseClick, false);
    return () => {
      document.removeEventListener('mousedown', handleMouseClick);
    };
  }, [showSelect, buttonRef, divRef]);

  return (
    <div style={{ position: 'relative' }}>
      <Button blue ref={buttonRef} onClick={() => setShowSelect(!showSelect)} style={style}>
        {btnText}
        <Img icon="icons/arrowhead-down-white" style={{ marginLeft: 10 }} />
      </Button>
      <div style={{ position: 'absolute', right: 0, zIndex: 100 }}>
        <div
          ref={divRef}
          style={{
            position: 'relative',
            height: dropdownHeight,
            right: 0,
            top: 0,
            display: showSelect ? 'flex' : 'none',
            flexDirection: 'column',
          }}
        >
          <TableSelect onChangeValue={onChangeValue} {...tsProps} isOpen={showSelect} />
        </div>
      </div>
    </div>
  );
};

const getDefaultBtnText = ({ items, defaultSelect, selectRowName }: ITableSelectProps) => {
  const item = items.find(({ value }) => value === defaultSelect);
  if (!!item) {
    return item.title;
  }
  if (!!selectRowName) {
    return `(${selectRowName})`;
  }
  return '(Select)';
};

export default TableSelectButton;
